import { z } from "zod/v4";

/**
 * Bank transfer settings validation schema
 */
export const bankTransferSettingsSchema = z.object({
  bankName: z.string().min(1, "Bank name is required"),
  accountNumber: z.string().min(1, "Account number is required"),
  accountName: z.string().min(1, "Account holder is required"),
  branch: z.string().optional(),
  swiftCode: z.string().optional(),
});

export type BankTransferSettingsFormData = z.infer<
  typeof bankTransferSettingsSchema
>;
